import { Heart, Clock, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import InsightShareMenu from "./InsightShareMenu";

interface InsightCardFooterProps {
  readingTime: number;
  likesCount: number;
  viewsCount: number;
  isLiked: boolean;
  onLike: () => void;
  url: string;
  title: string;
  thumbnailUrl?: string;
}

const InsightCardFooter = ({
  readingTime,
  likesCount,
  viewsCount,
  isLiked,
  onLike,
  url,
  title,
  thumbnailUrl,
}: InsightCardFooterProps) => {
  return (
    <div className="flex items-center justify-between border-t border-gray-100 pt-4">
      <div className="flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-gray-500">
          <Clock className="w-3.5 h-3.5 shrink-0" />
          {readingTime || 5} min read
        </span>
        <span className="text-gray-300">·</span>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-gray-500">
          <Eye className="w-3.5 h-3.5 shrink-0" />
          {viewsCount}
        </span>
      </div>
      
      <div className="relative z-10 flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          className={`h-7 px-2 gap-1.5 hover:text-red-500 ${isLiked ? 'text-red-500' : 'text-gray-400'}`}
          onClick={onLike}
        >
          <Heart className={`w-3.5 h-3.5 ${isLiked ? 'fill-current' : ''}`} />
          <span className="text-xs text-gray-600">{likesCount}</span>
        </Button>
        <InsightShareMenu url={url} title={title} thumbnailUrl={thumbnailUrl} />
      </div>
    </div>
  );
};

export default InsightCardFooter;